import { render, staticRenderFns } from "./AdminSearchView.vue?vue&type=template&id=1ae3f0c6&scoped=true"
import script from "./AdminSearchView.vue?vue&type=script&lang=js"
export * from "./AdminSearchView.vue?vue&type=script&lang=js"
import style0 from "./AdminSearchView.vue?vue&type=style&index=0&id=1ae3f0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae3f0c6",
  null
  
)

export default component.exports